function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#CDCCCC",
  d: "M487.1 576.7L263.7 706.5 38.9 576.7l223.4-129.8z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F59333",
  d: "M488.5 309.9l-.8 258.3-224.8-129.8.8-258.3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#CDCCCC",
  d: "M254.3 183.3l.7 258.3L30.2 571.4l-.7-258.3z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F59333",
  d: "M715.8 173.3L492.4 303.1 267.6 173.3 491 43.5zM719.8 180.1l.7 258.3-224.8 129.8-.7-258.3z"
});

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 750",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNzUwIDc1MCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNzUwIDc1MCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8Zz4NCgkJPGc+DQoJCQk8Zz4NCgkJCQk8cG9seWdvbiBmaWxsPSIjQ0RDQ0NDIiBwb2ludHM9IjQ4Ny4xLDU3Ni43IDI2My43LDcwNi41IDM4LjksNTc2LjcgMjYyLjMsNDQ2LjkgCQkJCSIvPg0KCQkJPC9nPg0KCQk8L2c+DQoJPC9nPg0KCTxnPg0KCQk8Zz4NCgkJCTxnPg0KCQkJCTxwb2x5Z29uIGZpbGw9IiNGNTkzMzMiIHBvaW50cz0iNDg4LjUsMzA5LjkgNDg3LjcsNTY4LjIgMjYyLjksNDM4LjQgMjYzLjcsMTgwLjEgCQkJCSIvPg0KCQkJPC9nPg0KCQk8L2c+DQoJPC9nPg0KCTxnPg0KCQk8Zz4NCgkJCTxnPg0KCQkJCTxwb2x5Z29uIGZpbGw9IiNDRENDQ0MiIHBvaW50cz0iMjU0LjMsMTgzLjMgMjU1LDQ0MS42IDMwLjIsNTcxLjQgMjkuNSwzMTMuMSAJCQkJIi8+DQoJCQk8L2c+DQoJCTwvZz4NCgk8L2c+DQoJPGc+DQoJCTxnPg0KCQkJPGc+DQoJCQkJPHBvbHlnb24gZmlsbD0iI0Y1OTMzMyIgcG9pbnRzPSI3MTUuOCwxNzMuMyA0OTIuNCwzMDMuMSAyNjcuNiwxNzMuMyA0OTEsNDMuNSAJCQkJIi8+DQoJCQk8L2c+DQoJCTwvZz4NCgk8L2c+DQoJPGc+DQoJCTxnPg0KCQkJPGc+DQoJCQkJPHBvbHlnb24gZmlsbD0iI0Y1OTMzMyIgcG9pbnRzPSI3MTkuOCwxODAuMSA3MjAuNSw0MzguNCA0OTUuNyw1NjguMiA0OTUsMzA5LjkgCQkJCSIvPg0KCQkJPC9nPg0KCQk8L2c+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo=";
export { SvgLogo as ReactComponent };